import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

export default function Menu() {
    const user = useSelector((state) => state.Login.user);
    const [menuItems, setMenuItems] = useState([]);
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    useEffect(() => {
        if (user?.id) {
            setMenuItems(user.models || []);
        }
    }, [user]);

    const toggleMenu = () => setIsMenuOpen((prev) => !prev);

    const isActiveRoute = (item) => {
        if (!item) return false;
        const current = location.pathname;
        if (current === item.link) return true;
        if (item.associatedRoutes?.includes(current)) return true;
        return false;
    };

    return (
        <div className="relative flex h-screen">
            {/* Top bar for mobile */}
            <div className="fixed top-0 left-0 right-0 z-40 flex items-center justify-between bg-cs-bg border-b border-cs-border px-4 py-3 lg:hidden">
                <div className="flex items-center gap-2">
                    <img
                        src="/logoB.png"
                        alt="CargoSmart Logo"
                        className="h-8 w-auto object-contain"
                    />
                </div>
                <button
                    onClick={toggleMenu}
                    className="inline-flex items-center justify-center w-9 h-9 rounded-xl border border-cs-border text-cs-dark hover:bg-cs-bg-alt hover:text-cs-primary transition-colors"
                >
                    <span className="material-symbols-outlined text-base">
                        {isMenuOpen ? 'close' : 'menu'}
                    </span>
                </button>
            </div>

            {/* Sidebar */}
            <aside
                className={`
    fixed lg:static z-30
    top-[56px] lg:top-0
    left-0
    h-[calc(100vh-56px)] lg:h-full
    w-64
    bg-gradient-to-b from-cs-primary-dark to-cs-surface-dark
    border-r border-cs-primary/20
    flex flex-col
    transition-transform duration-200
    ${isMenuOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
  `}
            >
                <nav className="flex-1 overflow-y-auto px-3 py-4 space-y-1">
                    {menuItems.map((item, index) => {
                        if (item.menu) {
                            const active = isActiveRoute(item);
                            return (
                                <Link
                                    key={index}
                                    to={item.link}
                                    className={`
            flex items-center gap-3 px-3 py-2.5 rounded-2xl text-sm transition-all
            ${active
                                            ? 'bg-white/10 text-white font-semibold'
                                            : 'text-white/70 hover:bg-white/10 hover:text-white'
                                        }
          `}
                                >
                                    <span className="material-symbols-outlined text-[18px]">
                                        {item.icon}
                                    </span>
                                    <span className="truncate">{item.name}</span>
                                </Link>
                            );
                        }
                    })}
                </nav>

                <div className="px-4 py-3 border-t border-white/10 text-[10px] text-white/60 hidden lg:flex justify-between items-center">
                    <span>
                        Logged in as{' '}
                        <span className="font-medium text-white">
                            {user?.name || 'User'}
                        </span>
                    </span>
                </div>
            </aside>


            <div className="flex-1 lg:ml-0 pt-14 lg:pt-0">
                {/* Page content here */}
            </div>
        </div>
    );
}
